import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  FormControlLabel,
  Switch
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const RosterPublication = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Roster Publication</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Min Roster Publication Days"
              type="number"
              value={baseline.minRosterPublicationDays}
              onChange={(e) => handleChange('minRosterPublicationDays', parseInt(e.target.value))}
              inputProps={{ min: 1, max: 30 }}
              helperText="CAR Section 7, Series J - Minimum advance notice"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={baseline.requireWeeklyRestShown}
                  onChange={(e) => handleChange('requireWeeklyRestShown', e.target.checked)}
                />
              }
              label="Require Weekly Rest Shown (CAR Section 7, Series J)"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default RosterPublication;
